import { render, staticRenderFns } from "./save-location-dialog.component.vue?vue&type=template&id=473d396e"
import script from "./save-location-dialog.component.ts?vue&type=script&lang=ts&external"
export * from "./save-location-dialog.component.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/foex-3r/foex-3r-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('473d396e')) {
      api.createRecord('473d396e', component.options)
    } else {
      api.reload('473d396e', component.options)
    }
    module.hot.accept("./save-location-dialog.component.vue?vue&type=template&id=473d396e", function () {
      api.rerender('473d396e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/shared/save-location-dialog/save-location-dialog.component.vue"
export default component.exports